import styled from '@mint-lib/styled';
import ListItemButton from '@mui/material/ListItemButton';

import { getBoxShadow, getCursorStyle } from './DraggableItem.utils.js';

const StyledDraggableItem = styled(ListItemButton, {
  shouldForwardProp: (prop) =>
    prop !== 'isDragged' &&
    prop !== 'disabled' &&
    prop !== 'checkbox' &&
    prop !== 'description',
})<{
  isDragged?: boolean;
  checkbox?: boolean;
  disabled: boolean;
  description?: string;
}>(({ theme, isDragged, checkbox, disabled, description }) => ({
  transition: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  boxSizing: 'border-box',
  border: `1px solid ${theme.palette.ui.tertiary}`,
  backgroundColor: disabled
    ? theme.palette.action.disabledBackground
    : theme.palette.ui.primary,
  color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
  borderRadius: '8px',
  height: description ? '3rem' : '2rem',
  minWidth: '5rem',
  width: '100%',
  padding: checkbox ? '0 0.5rem 0 0' : '0 0.5rem',
  cursor: getCursorStyle({ isDragged, disabled }),
  '&:hover': {
    backgroundColor: disabled
      ? theme.palette.action.disabledBackground
      : theme.palette.ui.secondary,
  },
  boxShadow: getBoxShadow({ isDragged, disabled }),
}));

export default StyledDraggableItem;
